import { render, staticRenderFns } from "./RenameStageModal.vue?vue&type=template&id=61aa3fa6&"
import script from "./RenameStageModal.vue?vue&type=script&lang=js&"
export * from "./RenameStageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports